import chroma, { Color } from 'chroma-js';

/**
 * chroma-js library.
 */
export { chroma };

/**
 * chroma-js color.
 */
export type { Color };
